import { render, staticRenderFns } from "./MsgsQueueModal.vue?vue&type=template&id=e17999b4&scoped=true"
import script from "./MsgsQueueModal.vue?vue&type=script&lang=js"
export * from "./MsgsQueueModal.vue?vue&type=script&lang=js"
import style0 from "./MsgsQueueModal.vue?vue&type=style&index=0&id=e17999b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17999b4",
  null
  
)

export default component.exports